<template>
    <div>
        <datatablesimple :state="availabilityState"  style="width: 100%" />
    </div>
</template>

<script>
export default {
    name: 'availabilitytable',
    data() {
      return {
      }
    },
    props: {
        items: Array,
        stateMap: Object,
        typeMap: Object,
        presence: Boolean,
    },
    computed: {
        availabilityState() {
            let view = this;

            let state = {
                headerMap: [],
            };

            let columns = {}
            columns.spot = this.$tc('shift.main.position')
            columns.employee = this.$t('pages.employeeData.name')
            columns.from = this.$t('global.general.from')
            columns.to = this.$t('global.general.to')
            columns.stateLabel = this.$t('global.general.status')
            if (view.presence) {
                columns.weekdays = this.$tc('global.general.day', 2)
            } else {
                columns.type = this.$tc('global.general.type')
            }
            columns.checked = " "

            let data = Object.values(this.items);

            state = this.$helpers.GetDataTableStateFromKeyLabelObject(columns, data);

            view.$helpers.buildHeaderMapLabelStyle(state.headerMap, 'spot', view.styleLabelLeft);
            view.$helpers.buildHeaderMapLabelStyle(state.headerMap, 'employee', view.styleLabelLeft);

            view.$helpers.buildHeaderMapLabelStyle(state.headerMap, 'from', view.styleLabelLeft);
            state.headerMap.from.sort = true;
            view.$helpers.buildHeaderMapLabelStyle(state.headerMap, 'to', view.styleLabelLeft);
            state.headerMap.to.sort = true;
            view.$helpers.buildHeaderMapLabelStyle(state.headerMap, 'stateLabel', view.styleLabelLeft);
            if (view.stateMap[data.state] !== null) {
                state.headerMap.stateLabel.componentStateBuilders = [(data) => {
                    return {
                        componentType: 'labelc',
                        state: {
                            text: this.$i18n.locale === 'en' ? view.stateMap[data.state].label : view.stateMap[data.state].label_de,
                        },
                        styleLabel: view.styleLabelLeft,
                    }
                }];
            }

            if (view.presence) {
                view.$helpers.buildHeaderMapLabelStyle(state.headerMap, 'weekdays', view.styleLabelLeft);
                if (data.weekdays !== null) {
                    state.headerMap.weekdays.componentStateBuilders = [(data) => {
                        let dayEntry = data.weekdays;
                        return {
                            componentType: 'labelc',
                            state: {
                                text: dayEntry !== null ? view.translateDayEntry(dayEntry) : '',
                            },
                            styleLabel: view.styleLabelLeft,
                        }
                    }];
                }
            } else {
                view.$helpers.buildHeaderMapLabelStyle(state.headerMap, 'type', view.styleLabelLeft);
                if (view.typeMap[data.type] !== null) {
                    state.headerMap.type.componentStateBuilders = [(data) => {
                        let typeEntry = view.typeMap[data.type];
                        return {
                            componentType: 'labelc',
                            state: {
                                text: typeEntry !== null ? (this.$i18n.locale === 'en' ? typeEntry.label : typeEntry.label_de) : '',
                            },
                            styleLabel: view.styleLabelLeft,
                        }
                    }];
                }
            }

            state.headerMap.checked.componentTypeRow = 'checkbox';
            state.headerMap.checked.componentStateBuilders = [(data) => {
                return {
                    componentType: 'checkbox',
                    value: data.checked,
                    toggleCheck: true,
                    customEvents: {
                        Update: () => {
                            data.checked = !data.checked;
                        }
                    }
                }
            }];

            let entries = Object.entries(state.headerMap);

            let mainColumns = ['employee', 'stateLabel', 'weekdays', 'type'];
            let mainColumnWidth = 18;
            let secColumns = ['spot', 'active', 'from', 'to'];
            let secColumnWidth = 10;
            let actionColumns = ['checked'];
            let actionColumnWidth = 6;
            for (let x in entries) {
                if (mainColumns.includes(entries[x][0])) {
                    entries[x][1].width = mainColumnWidth + '%';
                } else if (secColumns.includes(entries[x][0])) {
                    entries[x][1].width = secColumnWidth + '%';
                } else if (actionColumns.includes(entries[x][0])) {
                    entries[x][1].width = actionColumnWidth + '%';
                }
                entries[x][1].key = entries[x][0];
            }

            state.headerStyles = {fontSize: '12px', position: "sticky", top: 0, zIndex: 10};
            state.heightSubRow = 'fit-content';
            state.rowStyles = {background: '#6d8d23'};
            state.rowStylesCollapsed = {fontSize: '10px'};
            state.sumRowStyles = {background: 'var(--sub-menu)'}
            state.alwaysUnfold = false;
            return state;
        },
    },
    methods: {
        translateDayEntry(val) {
            return val
                .split(', ')
                .map(day => this.$helpers.translateDayShort(day))
                .join(', ');
        },
    }
}
</script>

<style scoped>

</style>
